export default __webpack_public_path__ + "static/media/grafema_armazem-da-alfandega_13.6fb94c51.jpg";